/**
 * Org narrative Plan of Record instrument — secondary to the plan-cycle PoR home.
 * Index redirects to /planning/plans (primary cycle). Deep links remain for
 * narrative sections until folded into bottom-card subpages.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import PorList from './PorList';
import PorCreate from './PorCreate';
import PorWorkspace from './PorWorkspace';

export default function PorRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/planning/plans" replace />} />
      {/* Explicit catalog for narrative records (bottom-card / settings) */}
      <Route path="catalog" element={<PorList />} />
      <Route path="new" element={<PorCreate />} />
      <Route path=":id/*" element={<PorWorkspace />} />
      <Route path="*" element={<Navigate to="/planning/plans" replace />} />
    </Routes>
  );
}
